import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../../assets/images/chat/close.svg'
import _imports_1 from '../../../../assets/images/red-cancel.svg'
import _imports_2 from '../../../../assets/images/chat/cancel.svg'
import _imports_3 from '../../../../assets/images/chat/send.svg'


const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between px-3 pt-1 w-100 status-msg-bar"
}
const _hoisted_2 = { class: "status-msg-text" }
const _hoisted_3 = { id: "MessageCenter__Editor" }
const _hoisted_4 = { class: "editor-box w-100 position-relative" }
const _hoisted_5 = {
  key: 0,
  class: "fw-bold text-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex attachment-error-div"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-danger" }, " This file is already attached to your message.", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "d-flex important-div"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-danger" }, " IMPORTANT!", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "card bg-form-section material-card my-1 reply-message-body" }
const _hoisted_14 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_15 = { class: "message-info" }
const _hoisted_16 = { class: "me-2" }
const _hoisted_17 = { class: "me-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle fa-lg pe-1" }, null, -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */)
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = {
  key: 0,
  class: "ps-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle fa-lg pe-1" }, null, -1 /* HOISTED */)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { id: "MessageCenter__Files" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["files"]
const _hoisted_33 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showStatusMsgs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.chatStatusMsg), 1 /* TEXT */),
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeStatusMsg && _ctx.closeStatusMsg(...args))),
            class: "remove-btn cursor-pointer",
            src: _imports_0
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        (_ctx.showAttachmentLimitError)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Maximum of 25 attachments may be added to a message."))
          : _createCommentVNode("v-if", true),
        (_ctx.showDuplicateAttachmentError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("button", {
                type: "button",
                class: "me-2 mb-2 close close-icon text-danger",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDuplicateAttachmentError = false))
              }, _hoisted_9)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.editorMessage.isImportant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : _createCommentVNode("v-if", true),
        (_ctx.editorMessage.replyMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "d-flex important-div reply-div align-items-center",
              ref: `${_ctx.refsName}-replyMsg`
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.editorMessage.replyMessage.senderDetails.firstName) + " " + _toDisplayString(_ctx.editorMessage.replyMessage.senderDetails?.lastName
                                        ? _ctx.editorMessage.replyMessage.senderDetails?.lastName
                                        : ""), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatMessageTime(_ctx.editorMessage.replyMessage.modifiedOn)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("span", {
                    class: "ms-1 cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelReply && _ctx.cancelReply(...args)))
                  }, _hoisted_19)
                ]),
                (_ctx.editorMessage.replyMessage.text)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "reply-message-text my-1",
                      innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.editorMessage.replyMessage.text))
                    }, null, 8 /* PROPS */, _hoisted_20))
                  : (_ctx.replyMsgProfiles)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.replyMsgProfiles, (profile) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: profile.id,
                            class: "d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                          }, [
                            _hoisted_22,
                            _createElementVNode("span", null, _toDisplayString(profile.name), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
              ])
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(`d-flex text-editor ${_ctx.activeConversation?.hasUserLeftChat ? 'disable-editor' : ''} ${
                    _ctx.editorMessage.isImportant || _ctx.showDuplicateAttachmentError || _ctx.editorMessage.replyMessage
                        ? 'header-added'
                        : ''
                } ${_ctx.expandFilePreview || _ctx.expandProfilesPreview ? 'flex-column' : 'align-items-end'}`)
        }, [
          _createElementVNode("section", {
            ref: `${_ctx.refsName}-textMarkup`
          }, null, 512 /* NEED_PATCH */),
          (
                        !(_ctx.expandFilePreview || _ctx.expandProfilesPreview) &&
                        (_ctx.refsName === 'chatEditorRef' || _ctx.refsName.includes('threadEditorRef-'))
                    )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_23,
                _createElementVNode("img", {
                  class: _normalizeClass(`send-btn cursor-pointer ${_ctx.disableSend ? 'disableSend' : ''}`),
                  src: _imports_3,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.send()))
                }, null, 2 /* CLASS */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, [
                (_ctx.expandProfilesPreview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editorMessage.allSelectedProfiles, (profile) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: profile.agencyId,
                          class: "d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                        }, [
                          _hoisted_26,
                          (profile?.name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(profile.name), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(profile.lastName + " " + profile.firstName), 1 /* TEXT */)),
                          _createElementVNode("i", {
                            "data-actionType": "remove",
                            class: "fas fa-times-circle fa-md remove-profile-icon ps-2 pt-0 cursor-pointer",
                            onClick: ($event: any) => (_ctx.removeProfile(profile))
                          }, null, 8 /* PROPS */, _hoisted_29)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilesUI, (file) => {
                    return (_openBlock(), _createElementBlock("section", {
                      class: "files-choice",
                      key: file.fileName
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(`far ${file.iconClass} me-2`)
                      }, null, 2 /* CLASS */),
                      _createElementVNode("span", null, _toDisplayString(_ctx.truncateString(file.fileName, 30)), 1 /* TEXT */),
                      _createElementVNode("i", {
                        class: "fa fa-times ms-2 cursor-pointer",
                        onClick: ($event: any) => (_ctx.removeAttachment(file.fileName))
                      }, null, 8 /* PROPS */, _hoisted_31)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("input", {
                    type: "file",
                    multiple: "",
                    accept: "image/*, .pdf, .doc, .docx",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.uploadFilesChanged($event))),
                    files: _ctx.uploadFile,
                    class: "fileInput",
                    ref: `${_ctx.refsName}-uploadMarkup`,
                    hidden: ""
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32)
                ], 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.expandFilePreview]
                ])
              ]),
              (_ctx.refsName === 'chatEditorRef')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("img", {
                      class: _normalizeClass(`send-btn cursor-pointer align-self-end ${_ctx.disableSend ? 'disableSend' : ''}`),
                      src: _imports_3,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.send()))
                    }, null, 2 /* CLASS */)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.expandFilePreview || _ctx.expandProfilesPreview]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          ref: `${_ctx.refsName}-toolbar`,
          class: _normalizeClass(["editor-toolbar", `${_ctx.refsName}-editor-toolbar`])
        }, null, 2 /* CLASS */)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}